import { EpDevPDocumentTypes } from '../../constants';
import { 
  EpDevPApiClient 
} from '../EpDevPApiClient';
import {
  IEpDevPEnvironmentsApiClient,
  IEpDevPListEnvironmentsResponse,
  IEpDevPEnvironment
} from '../types';
import { EpDevPEnvironmentsApiPathsFactory } from './EpDevPEnvironmentsApiFactories';


export class EpDevPEnvironmentsApiClient extends EpDevPApiClient implements IEpDevPEnvironmentsApiClient {

  public async listEnvironments({ organizationId }:{
    organizationId: string;
  }): Promise<IEpDevPListEnvironmentsResponse> {
    const epDevPListEnvironmentsResponse: IEpDevPListEnvironmentsResponse = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPEnvironmentsApiPathsFactory.createListPath({ 
        organizationId: organizationId, 
      }))
    });
    return epDevPListEnvironmentsResponse;    
  };

  public async listCachedEnvironments({ organizationId, documentTypes }:{
    organizationId: string;
    documentTypes?: Array<EpDevPDocumentTypes>;
  }): Promise<IEpDevPListEnvironmentsResponse> {
    const epDevPListEnvironmentsResponse: IEpDevPListEnvironmentsResponse = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPEnvironmentsApiPathsFactory.createListCachedPath({ 
        organizationId: organizationId, 
        documentTypes: documentTypes
      }))
    });
    return epDevPListEnvironmentsResponse;    
  };

  public async getEnvironmentById({ organizationId, environmentId, add2CacheId }:{
    organizationId: string;
    environmentId: string;
    add2CacheId?: string;
  }): Promise<IEpDevPEnvironment> {
    const epDevPEnvironment: IEpDevPEnvironment = await this.request({
      method: 'GET',
      url: await this.createUrl(EpDevPEnvironmentsApiPathsFactory.createByIdPath({ 
        organizationId: organizationId, 
        environmentId: environmentId,
        add2CacheId: add2CacheId
      }))
    });
    return epDevPEnvironment;        
  }

  public async createEnvironmentsCache({ organizationId }: {
    organizationId: string;
  }): Promise<string> {
    const cacheId: string = await this.request({
      method: 'POST',
      url: await this.createUrl(EpDevPEnvironmentsApiPathsFactory.createCacheCreatePath({ 
        organizationId: organizationId,
      }))
    });
    return cacheId;
  }

  public async replaceEnvironmentsCache({ organizationId, sourceCacheId, organizationDocumentType }:{
    organizationId: string;
    sourceCacheId: string;
    organizationDocumentType: EpDevPDocumentTypes;
  }): Promise<void> {
    const xvoid: void = await this.request({
      method: 'PUT',
      url: await this.createUrl(EpDevPEnvironmentsApiPathsFactory.createCacheReplacePath({ 
        organizationId: organizationId,
        sourceCacheId: sourceCacheId,
        organizationDocumentType: organizationDocumentType
      }))
    });
    xvoid;
  }

  public async clearEnvironmentsCache({ organizationId, tempCacheId, organizationDocumentType }:{
    organizationId: string;
    tempCacheId?: string;
    organizationDocumentType: EpDevPDocumentTypes;
  }): Promise<void> {
    const xvoid: void = await this.request({
      method: 'DELETE',
      url: await this.createUrl(EpDevPEnvironmentsApiPathsFactory.createCacheDeletePath({ 
        organizationId: organizationId,
        tempCacheId: tempCacheId,
        organizationDocumentType: organizationDocumentType
      }))
    });
    xvoid;
  }

}
